var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 2.66699C19.4663 2.66699 17.4663 4.40033 15.9997 6.53366C14.533 4.40033 12.533 2.66699 9.99967 2.66699C5.19967 2.66699 1.33301 6.53366 1.33301 11.3337C1.33301 13.6003 2.26634 15.867 3.86634 17.467L15.0663 28.667C15.333 28.9337 15.733 29.067 15.9997 29.067C16.3997 29.067 16.6663 28.9337 16.933 28.667L27.333 18.4003C29.5997 16.1337 30.6663 13.867 30.6663 11.467C30.6663 6.53366 26.7997 2.66699 21.9997 2.66699Z",
    fill: "#0070A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFilledHeart);
export default __webpack_public_path__ + "static/media/bigFilledHeart.bf6e233aeea1b5fcac2bf6755f5c61b6.svg";
export { ForwardRef as ReactComponent };